import { useEffect } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getCollection } from "../api";
import { Paywall } from "../components/Paywall";
import { resumeTarget } from "../lib/rsvp";
import { Empty, ErrorBox, Loading, useResource } from "../ui";

/**
 * Not a screen: `/app/c/:slug` resolves where to start in the collection and
 * replaces itself with the player. `?from=first` starts at the first passage.
 */
export function Collection() {
  const { slug = "" } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { data, loading, error } = useResource(() => getCollection(slug), [slug]);
  const playable = data?.passages.filter((p) => !p.locked) ?? [];
  const target = params.get("from") === "first" ? (playable[0]?.id ?? null) : resumeTarget(playable);

  useEffect(() => {
    if (target) navigate(`/app/p/${target}`, { replace: true });
  }, [target]);

  if (loading || target) return <Loading />;
  return (
    <div className="mx-auto max-w-2xl">
      <Link to="/app" className="text-[12px] font-bold text-ink-2 hover:text-shu">
        × ホームへ
      </Link>
      <div className="mt-4">
        {error || !data ? (
          <ErrorBox message={error ?? "コレクションが見つかりません。"} />
        ) : data.collection.locked && data.passages.length ? (
          <Paywall title={data.collection.title} />
        ) : (
          <Empty>パッセージはまだありません。</Empty>
        )}
      </div>
    </div>
  );
}
